module.exports = __webpack_public_path__ + "img/cb_x.6b6f2f24.svg";